import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1659fb4b = () => interopDefault(import('../pages/condicoes-utilizacao/index.vue' /* webpackChunkName: "pages/condicoes-utilizacao/index" */))
const _6f5c88b4 = () => interopDefault(import('../pages/contacte-nos/index.vue' /* webpackChunkName: "pages/contacte-nos/index" */))
const _778f8909 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ed8bb1d2 = () => interopDefault(import('../pages/home.js' /* webpackChunkName: "pages/home" */))
const _bbdb4a82 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/index" */))
const _58c349a3 = () => interopDefault(import('../pages/simulacao-seguro-saude/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/index" */))
const _2f7d9f08 = () => interopDefault(import('../pages/simulacao-seguro-viagem/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/index" */))
const _2e71efab = () => interopDefault(import('../pages/simulacao-seguro-vida/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/index" */))
const _718f360f = () => interopDefault(import('../pages/condicoes-utilizacao/terms.js' /* webpackChunkName: "pages/condicoes-utilizacao/terms" */))
const _2064301b = () => interopDefault(import('../pages/contacte-nos/contact.js' /* webpackChunkName: "pages/contacte-nos/contact" */))
const _65c20bce = () => interopDefault(import('../pages/contacte-nos/obrigado/index.vue' /* webpackChunkName: "pages/contacte-nos/obrigado/index" */))
const _7d4d73cc = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/index" */))
const _2aff7e31 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/index" */))
const _14eff85d = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos" */))
const _605c2024 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/simulador/index" */))
const _023025ee = () => interopDefault(import('../pages/simulacao-seguro-saude/simulacao-seguro-saude.js' /* webpackChunkName: "pages/simulacao-seguro-saude/simulacao-seguro-saude" */))
const _962a7bf0 = () => interopDefault(import('../pages/simulacao-seguro-saude/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/simulador/index" */))
const _281d98a3 = () => interopDefault(import('../pages/simulacao-seguro-viagem/simulacao-seguro-viagem.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/simulacao-seguro-viagem" */))
const _7a9cada1 = () => interopDefault(import('../pages/simulacao-seguro-viagem/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/simulador/index" */))
const _81b716f6 = () => interopDefault(import('../pages/simulacao-seguro-vida/simulacao-seguro-vida.js' /* webpackChunkName: "pages/simulacao-seguro-vida/simulacao-seguro-vida" */))
const _87b103e0 = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/index" */))
const _d54fe268 = () => interopDefault(import('../pages/contacte-nos/obrigado/obrigado.js' /* webpackChunkName: "pages/contacte-nos/obrigado/obrigado" */))
const _722a22d7 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/simulation" */))
const _5afdd2f2 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/simulation" */))
const _f8a2d96c = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/simulador/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/simulador/simulation" */))
const _4ea91125 = () => interopDefault(import('../pages/simulacao-seguro-saude/simulador/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-saude/simulador/simulador" */))
const _4a70d2ec = () => interopDefault(import('../pages/simulacao-seguro-viagem/simulador/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/simulador/simulador" */))
const _f9330fc6 = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/simulador" */))
const _51a854cd = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/index" */))
const _6529aaa6 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/_companyId/index" */))
const _b65d939c = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/_companyId/index" */))
const _3f0f9f75 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/index" */))
const _56e2e7de = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/index" */))
const _05260fd0 = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/index" */))
const _60e3d5ee = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/index" */))
const _755cd96e = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/_companyId/index" */))
const _65b33153 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador-novo/_companyId/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador-novo/_companyId/simulation" */))
const _87241b50 = () => interopDefault(import('../pages/simulacao-seguro-automovel/simulador/_companyId/simulation.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/simulador/_companyId/simulation" */))
const _c9773d84 = () => interopDefault(import('../pages/simulacao-seguro-casa/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-casa/resultados/_id/results" */))
const _57049696 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/results" */))
const _71633d7a = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/results" */))
const _64525253 = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/results" */))
const _535658fc = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/results.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/results" */))
const _6b99f7ff = () => interopDefault(import('../pages/simulacao-seguro-vida/simulador/_companyId/simulador.js' /* webpackChunkName: "pages/simulacao-seguro-vida/simulador/_companyId/simulador" */))
const _193d8e2a = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/index" */))
const _aa0cb10e = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/index" */))
const _912a7ce4 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/index" */))
const _7d2e09ee = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/_plan/index" */))
const _57b8e615 = () => interopDefault(import('../pages/simulacao-seguro-saude/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/obrigado/_id/_plan/index" */))
const _d0e0c9ac = () => interopDefault(import('../pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/index" */))
const _11cfdcec = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/_plan/index" */))
const _583812c8 = () => interopDefault(import('../pages/simulacao-seguro-viagem/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/obrigado/_id/_plan/index" */))
const _5097ea71 = () => interopDefault(import('../pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/index" */))
const _14c11c51 = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/_plan/index" */))
const _455b330d = () => interopDefault(import('../pages/simulacao-seguro-vida/obrigado/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/obrigado/_id/_plan/index" */))
const _475b63bc = () => interopDefault(import('../pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/index" */))
const _0e334656 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/index" */))
const _055b0082 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_plan/index" */))
const _2ce62be0 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/results.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/results" */))
const _6b176bb7 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/obrigado/_id/_plan/obrigado" */))
const _146be733 = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/pedir-contacto/_id/_plan/contact" */))
const _7df6dd1e = () => interopDefault(import('../pages/simulacao-seguro-multirriscos/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-multirriscos/resultados/_id/_plan/details" */))
const _35fd195a = () => interopDefault(import('../pages/simulacao-seguro-saude/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-saude/obrigado/_id/_plan/obrigado" */))
const _38e24117 = () => interopDefault(import('../pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-saude/pedir-contacto/_id/_plan/contact" */))
const _f7490556 = () => interopDefault(import('../pages/simulacao-seguro-saude/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-saude/resultados/_id/_plan/details" */))
const _02aa7e1a = () => interopDefault(import('../pages/simulacao-seguro-viagem/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/obrigado/_id/_plan/obrigado" */))
const _be384aa0 = () => interopDefault(import('../pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/pedir-contacto/_id/_plan/contact" */))
const _1bd3cb6e = () => interopDefault(import('../pages/simulacao-seguro-viagem/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-viagem/resultados/_id/_plan/details" */))
const _19773b6a = () => interopDefault(import('../pages/simulacao-seguro-vida/obrigado/_id/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-vida/obrigado/_id/_plan/obrigado" */))
const _e71425c2 = () => interopDefault(import('../pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-vida/pedir-contacto/_id/_plan/contact" */))
const _4ff4f594 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/results.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/results" */))
const _3e766d5d = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_plan/details" */))
const _4788b22f = () => interopDefault(import('../pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/index" */))
const _557c4684 = () => interopDefault(import('../pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/index" */))
const _aeb048a2 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/index" */))
const _276f9a38 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/index" */))
const _62cd8164 = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/index" */))
const _200ea0ed = () => interopDefault(import('../pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/obrigado.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/obrigado/_id/_hash/_plan/obrigado" */))
const _388b00fd = () => interopDefault(import('../pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/contact.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/pedir-contacto/_id/_hash/_plan/contact" */))
const _2073e19c = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/results.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/results" */))
const _352f873b = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_hash/_plan/details" */))
const _c5ffefde = () => interopDefault(import('../pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-vida/resultados/_id/_companyId/_plan/details" */))
const _46d2b2a8 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/index.vue' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/index" */))
const _2bf4fff7 = () => interopDefault(import('../pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/details.js' /* webpackChunkName: "pages/simulacao-seguro-automovel/resultados/_id/_companyId/_hash/_plan/details" */))
const _60ddb676 = () => interopDefault(import('../pages/detalhes-companhia/_companyName/_companyId/_type/index.vue' /* webpackChunkName: "pages/detalhes-companhia/_companyName/_companyId/_type/index" */))
const _034560ba = () => interopDefault(import('../pages/detalhes-companhia/_companyName/_companyId/_type/detalhes-companhia.js' /* webpackChunkName: "pages/detalhes-companhia/_companyName/_companyId/_type/detalhes-companhia" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/condicoes-utilizacao",
    component: _1659fb4b,
    name: "condicoes-utilizacao"
  }, {
    path: "/contacte-nos",
    component: _6f5c88b4,
    name: "contacte-nos"
  }, {
    path: "/en",
    component: _778f8909,
    name: "index___en"
  }, {
    path: "/home",
    component: _ed8bb1d2,
    name: "home"
  }, {
    path: "/pt",
    component: _778f8909,
    name: "index___pt"
  }, {
    path: "/simulacao-seguro-multirriscos",
    component: _bbdb4a82,
    name: "simulacao-seguro-multirriscos"
  }, {
    path: "/simulacao-seguro-saude",
    component: _58c349a3,
    name: "simulacao-seguro-saude"
  }, {
    path: "/simulacao-seguro-viagem",
    component: _2f7d9f08,
    name: "simulacao-seguro-viagem"
  }, {
    path: "/simulacao-seguro-vida",
    component: _2e71efab,
    name: "simulacao-seguro-vida"
  }, {
    path: "/condicoes-utilizacao/terms",
    component: _718f360f,
    name: "condicoes-utilizacao-terms"
  }, {
    path: "/contacte-nos/contact",
    component: _2064301b,
    name: "contacte-nos-contact"
  }, {
    path: "/contacte-nos/obrigado",
    component: _65c20bce,
    name: "contacte-nos-obrigado"
  }, {
    path: "/en/condicoes-utilizacao",
    component: _1659fb4b,
    name: "condicoes-utilizacao___en"
  }, {
    path: "/en/contacte-nos",
    component: _6f5c88b4,
    name: "contacte-nos___en"
  }, {
    path: "/en/home",
    component: _ed8bb1d2,
    name: "home___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos",
    component: _bbdb4a82,
    name: "simulacao-seguro-multirriscos___en"
  }, {
    path: "/en/simulacao-seguro-saude",
    component: _58c349a3,
    name: "simulacao-seguro-saude___en"
  }, {
    path: "/en/simulacao-seguro-viagem",
    component: _2f7d9f08,
    name: "simulacao-seguro-viagem___en"
  }, {
    path: "/en/simulacao-seguro-vida",
    component: _2e71efab,
    name: "simulacao-seguro-vida___en"
  }, {
    path: "/pt/condicoes-utilizacao",
    component: _1659fb4b,
    name: "condicoes-utilizacao___pt"
  }, {
    path: "/pt/contacte-nos",
    component: _6f5c88b4,
    name: "contacte-nos___pt"
  }, {
    path: "/pt/home",
    component: _ed8bb1d2,
    name: "home___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos",
    component: _bbdb4a82,
    name: "simulacao-seguro-multirriscos___pt"
  }, {
    path: "/pt/simulacao-seguro-saude",
    component: _58c349a3,
    name: "simulacao-seguro-saude___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem",
    component: _2f7d9f08,
    name: "simulacao-seguro-viagem___pt"
  }, {
    path: "/pt/simulacao-seguro-vida",
    component: _2e71efab,
    name: "simulacao-seguro-vida___pt"
  }, {
    path: "/simulacao-seguro-automovel/simulador",
    component: _7d4d73cc,
    name: "simulacao-seguro-automovel-simulador"
  }, {
    path: "/simulacao-seguro-automovel/simulador-novo",
    component: _2aff7e31,
    name: "simulacao-seguro-automovel-simulador-novo"
  }, {
    path: "/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos",
    component: _14eff85d,
    name: "simulacao-seguro-multirriscos-simulacao-seguro-multirriscos"
  }, {
    path: "/simulacao-seguro-multirriscos/simulador",
    component: _605c2024,
    name: "simulacao-seguro-multirriscos-simulador"
  }, {
    path: "/simulacao-seguro-saude/simulacao-seguro-saude",
    component: _023025ee,
    name: "simulacao-seguro-saude-simulacao-seguro-saude"
  }, {
    path: "/simulacao-seguro-saude/simulador",
    component: _962a7bf0,
    name: "simulacao-seguro-saude-simulador"
  }, {
    path: "/simulacao-seguro-viagem/simulacao-seguro-viagem",
    component: _281d98a3,
    name: "simulacao-seguro-viagem-simulacao-seguro-viagem"
  }, {
    path: "/simulacao-seguro-viagem/simulador",
    component: _7a9cada1,
    name: "simulacao-seguro-viagem-simulador"
  }, {
    path: "/simulacao-seguro-vida/simulacao-seguro-vida",
    component: _81b716f6,
    name: "simulacao-seguro-vida-simulacao-seguro-vida"
  }, {
    path: "/simulacao-seguro-vida/simulador",
    component: _87b103e0,
    name: "simulacao-seguro-vida-simulador"
  }, {
    path: "/contacte-nos/obrigado/obrigado",
    component: _d54fe268,
    name: "contacte-nos-obrigado-obrigado"
  }, {
    path: "/en/condicoes-utilizacao/terms",
    component: _718f360f,
    name: "condicoes-utilizacao-terms___en"
  }, {
    path: "/en/contacte-nos/contact",
    component: _2064301b,
    name: "contacte-nos-contact___en"
  }, {
    path: "/en/contacte-nos/obrigado",
    component: _65c20bce,
    name: "contacte-nos-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador",
    component: _7d4d73cc,
    name: "simulacao-seguro-automovel-simulador___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo",
    component: _2aff7e31,
    name: "simulacao-seguro-automovel-simulador-novo___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos",
    component: _14eff85d,
    name: "simulacao-seguro-multirriscos-simulacao-seguro-multirriscos___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/simulador",
    component: _605c2024,
    name: "simulacao-seguro-multirriscos-simulador___en"
  }, {
    path: "/en/simulacao-seguro-saude/simulacao-seguro-saude",
    component: _023025ee,
    name: "simulacao-seguro-saude-simulacao-seguro-saude___en"
  }, {
    path: "/en/simulacao-seguro-saude/simulador",
    component: _962a7bf0,
    name: "simulacao-seguro-saude-simulador___en"
  }, {
    path: "/en/simulacao-seguro-viagem/simulacao-seguro-viagem",
    component: _281d98a3,
    name: "simulacao-seguro-viagem-simulacao-seguro-viagem___en"
  }, {
    path: "/en/simulacao-seguro-viagem/simulador",
    component: _7a9cada1,
    name: "simulacao-seguro-viagem-simulador___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulacao-seguro-vida",
    component: _81b716f6,
    name: "simulacao-seguro-vida-simulacao-seguro-vida___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador",
    component: _87b103e0,
    name: "simulacao-seguro-vida-simulador___en"
  }, {
    path: "/pt/condicoes-utilizacao/terms",
    component: _718f360f,
    name: "condicoes-utilizacao-terms___pt"
  }, {
    path: "/pt/contacte-nos/contact",
    component: _2064301b,
    name: "contacte-nos-contact___pt"
  }, {
    path: "/pt/contacte-nos/obrigado",
    component: _65c20bce,
    name: "contacte-nos-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador",
    component: _7d4d73cc,
    name: "simulacao-seguro-automovel-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo",
    component: _2aff7e31,
    name: "simulacao-seguro-automovel-simulador-novo___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/simulacao-seguro-multirriscos",
    component: _14eff85d,
    name: "simulacao-seguro-multirriscos-simulacao-seguro-multirriscos___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/simulador",
    component: _605c2024,
    name: "simulacao-seguro-multirriscos-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/simulacao-seguro-saude",
    component: _023025ee,
    name: "simulacao-seguro-saude-simulacao-seguro-saude___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/simulador",
    component: _962a7bf0,
    name: "simulacao-seguro-saude-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/simulacao-seguro-viagem",
    component: _281d98a3,
    name: "simulacao-seguro-viagem-simulacao-seguro-viagem___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/simulador",
    component: _7a9cada1,
    name: "simulacao-seguro-viagem-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulacao-seguro-vida",
    component: _81b716f6,
    name: "simulacao-seguro-vida-simulacao-seguro-vida___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador",
    component: _87b103e0,
    name: "simulacao-seguro-vida-simulador___pt"
  }, {
    path: "/simulacao-seguro-automovel/simulador-novo/simulation",
    component: _722a22d7,
    name: "simulacao-seguro-automovel-simulador-novo-simulation"
  }, {
    path: "/simulacao-seguro-automovel/simulador/simulation",
    component: _5afdd2f2,
    name: "simulacao-seguro-automovel-simulador-simulation"
  }, {
    path: "/simulacao-seguro-multirriscos/simulador/simulation",
    component: _f8a2d96c,
    name: "simulacao-seguro-multirriscos-simulador-simulation"
  }, {
    path: "/simulacao-seguro-saude/simulador/simulador",
    component: _4ea91125,
    name: "simulacao-seguro-saude-simulador-simulador"
  }, {
    path: "/simulacao-seguro-viagem/simulador/simulador",
    component: _4a70d2ec,
    name: "simulacao-seguro-viagem-simulador-simulador"
  }, {
    path: "/simulacao-seguro-vida/simulador/simulador",
    component: _f9330fc6,
    name: "simulacao-seguro-vida-simulador-simulador"
  }, {
    path: "/en/contacte-nos/obrigado/obrigado",
    component: _d54fe268,
    name: "contacte-nos-obrigado-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo/simulation",
    component: _722a22d7,
    name: "simulacao-seguro-automovel-simulador-novo-simulation___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador/simulation",
    component: _5afdd2f2,
    name: "simulacao-seguro-automovel-simulador-simulation___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/simulador/simulation",
    component: _f8a2d96c,
    name: "simulacao-seguro-multirriscos-simulador-simulation___en"
  }, {
    path: "/en/simulacao-seguro-saude/simulador/simulador",
    component: _4ea91125,
    name: "simulacao-seguro-saude-simulador-simulador___en"
  }, {
    path: "/en/simulacao-seguro-viagem/simulador/simulador",
    component: _4a70d2ec,
    name: "simulacao-seguro-viagem-simulador-simulador___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador/simulador",
    component: _f9330fc6,
    name: "simulacao-seguro-vida-simulador-simulador___en"
  }, {
    path: "/pt/contacte-nos/obrigado/obrigado",
    component: _d54fe268,
    name: "contacte-nos-obrigado-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo/simulation",
    component: _722a22d7,
    name: "simulacao-seguro-automovel-simulador-novo-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador/simulation",
    component: _5afdd2f2,
    name: "simulacao-seguro-automovel-simulador-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/simulador/simulation",
    component: _f8a2d96c,
    name: "simulacao-seguro-multirriscos-simulador-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/simulador/simulador",
    component: _4ea91125,
    name: "simulacao-seguro-saude-simulador-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/simulador/simulador",
    component: _4a70d2ec,
    name: "simulacao-seguro-viagem-simulador-simulador___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador/simulador",
    component: _f9330fc6,
    name: "simulacao-seguro-vida-simulador-simulador___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id",
    component: _51a854cd,
    name: "simulacao-seguro-automovel-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo/:companyId",
    component: _6529aaa6,
    name: "simulacao-seguro-automovel-simulador-novo-companyId___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador/:companyId",
    component: _b65d939c,
    name: "simulacao-seguro-automovel-simulador-companyId___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id",
    component: _3f0f9f75,
    name: "simulacao-seguro-multirriscos-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id",
    component: _56e2e7de,
    name: "simulacao-seguro-saude-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id",
    component: _05260fd0,
    name: "simulacao-seguro-viagem-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id",
    component: _60e3d5ee,
    name: "simulacao-seguro-vida-resultados-id___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador/:companyId",
    component: _755cd96e,
    name: "simulacao-seguro-vida-simulador-companyId___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id",
    component: _51a854cd,
    name: "simulacao-seguro-automovel-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo/:companyId",
    component: _6529aaa6,
    name: "simulacao-seguro-automovel-simulador-novo-companyId___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador/:companyId",
    component: _b65d939c,
    name: "simulacao-seguro-automovel-simulador-companyId___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id",
    component: _3f0f9f75,
    name: "simulacao-seguro-multirriscos-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id",
    component: _56e2e7de,
    name: "simulacao-seguro-saude-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id",
    component: _05260fd0,
    name: "simulacao-seguro-viagem-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id",
    component: _60e3d5ee,
    name: "simulacao-seguro-vida-resultados-id___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador/:companyId",
    component: _755cd96e,
    name: "simulacao-seguro-vida-simulador-companyId___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador-novo/:companyId?/simulation",
    component: _65b33153,
    name: "simulacao-seguro-automovel-simulador-novo-companyId-simulation___en"
  }, {
    path: "/en/simulacao-seguro-automovel/simulador/:companyId?/simulation",
    component: _87241b50,
    name: "simulacao-seguro-automovel-simulador-companyId-simulation___en"
  }, {
    path: "/en/simulacao-seguro-casa/resultados/:id?/results",
    component: _c9773d84,
    name: "simulacao-seguro-casa-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id?/results",
    component: _57049696,
    name: "simulacao-seguro-multirriscos-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id?/results",
    component: _71633d7a,
    name: "simulacao-seguro-saude-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id?/results",
    component: _64525253,
    name: "simulacao-seguro-viagem-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/results",
    component: _535658fc,
    name: "simulacao-seguro-vida-resultados-id-results___en"
  }, {
    path: "/en/simulacao-seguro-vida/simulador/:companyId?/simulador",
    component: _6b99f7ff,
    name: "simulacao-seguro-vida-simulador-companyId-simulador___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador-novo/:companyId?/simulation",
    component: _65b33153,
    name: "simulacao-seguro-automovel-simulador-novo-companyId-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/simulador/:companyId?/simulation",
    component: _87241b50,
    name: "simulacao-seguro-automovel-simulador-companyId-simulation___pt"
  }, {
    path: "/pt/simulacao-seguro-casa/resultados/:id?/results",
    component: _c9773d84,
    name: "simulacao-seguro-casa-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id?/results",
    component: _57049696,
    name: "simulacao-seguro-multirriscos-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id?/results",
    component: _71633d7a,
    name: "simulacao-seguro-saude-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id?/results",
    component: _64525253,
    name: "simulacao-seguro-viagem-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/results",
    component: _535658fc,
    name: "simulacao-seguro-vida-resultados-id-results___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/simulador/:companyId?/simulador",
    component: _6b99f7ff,
    name: "simulacao-seguro-vida-simulador-companyId-simulador___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash",
    component: _193d8e2a,
    name: "simulacao-seguro-automovel-resultados-id-hash___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/obrigado/:id?/:plan",
    component: _aa0cb10e,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan",
    component: _912a7ce4,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id?/:plan",
    component: _7d2e09ee,
    name: "simulacao-seguro-multirriscos-resultados-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-saude/obrigado/:id?/:plan",
    component: _57b8e615,
    name: "simulacao-seguro-saude-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-saude/pedir-contacto/:id?/:plan",
    component: _d0e0c9ac,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id?/:plan",
    component: _11cfdcec,
    name: "simulacao-seguro-saude-resultados-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-viagem/obrigado/:id?/:plan",
    component: _583812c8,
    name: "simulacao-seguro-viagem-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-viagem/pedir-contacto/:id?/:plan",
    component: _5097ea71,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id?/:plan",
    component: _14c11c51,
    name: "simulacao-seguro-viagem-resultados-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/obrigado/:id?/:plan",
    component: _455b330d,
    name: "simulacao-seguro-vida-obrigado-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/pedir-contacto/:id?/:plan",
    component: _475b63bc,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId",
    component: _0e334656,
    name: "simulacao-seguro-vida-resultados-id-companyId___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:plan",
    component: _055b0082,
    name: "simulacao-seguro-vida-resultados-id-plan___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash",
    component: _193d8e2a,
    name: "simulacao-seguro-automovel-resultados-id-hash___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/obrigado/:id?/:plan",
    component: _aa0cb10e,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan",
    component: _912a7ce4,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id?/:plan",
    component: _7d2e09ee,
    name: "simulacao-seguro-multirriscos-resultados-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/obrigado/:id?/:plan",
    component: _57b8e615,
    name: "simulacao-seguro-saude-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/pedir-contacto/:id?/:plan",
    component: _d0e0c9ac,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id?/:plan",
    component: _11cfdcec,
    name: "simulacao-seguro-saude-resultados-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/obrigado/:id?/:plan",
    component: _583812c8,
    name: "simulacao-seguro-viagem-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/pedir-contacto/:id?/:plan",
    component: _5097ea71,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id?/:plan",
    component: _14c11c51,
    name: "simulacao-seguro-viagem-resultados-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/obrigado/:id?/:plan",
    component: _455b330d,
    name: "simulacao-seguro-vida-obrigado-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/pedir-contacto/:id?/:plan",
    component: _475b63bc,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId",
    component: _0e334656,
    name: "simulacao-seguro-vida-resultados-id-companyId___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:plan",
    component: _055b0082,
    name: "simulacao-seguro-vida-resultados-id-plan___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash?/results",
    component: _2ce62be0,
    name: "simulacao-seguro-automovel-resultados-id-hash-results___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/obrigado/:id?/:plan/obrigado",
    component: _6b176bb7,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan/contact",
    component: _146be733,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-multirriscos/resultados/:id?/:plan/details",
    component: _7df6dd1e,
    name: "simulacao-seguro-multirriscos-resultados-id-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-saude/obrigado/:id?/:plan/obrigado",
    component: _35fd195a,
    name: "simulacao-seguro-saude-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-saude/pedir-contacto/:id?/:plan/contact",
    component: _38e24117,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-saude/resultados/:id?/:plan/details",
    component: _f7490556,
    name: "simulacao-seguro-saude-resultados-id-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-viagem/obrigado/:id?/:plan/obrigado",
    component: _02aa7e1a,
    name: "simulacao-seguro-viagem-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-viagem/pedir-contacto/:id?/:plan/contact",
    component: _be384aa0,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-viagem/resultados/:id?/:plan/details",
    component: _1bd3cb6e,
    name: "simulacao-seguro-viagem-resultados-id-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-vida/obrigado/:id?/:plan/obrigado",
    component: _19773b6a,
    name: "simulacao-seguro-vida-obrigado-id-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-vida/pedir-contacto/:id?/:plan/contact",
    component: _e71425c2,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId/results",
    component: _4ff4f594,
    name: "simulacao-seguro-vida-resultados-id-companyId-results___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:plan/details",
    component: _3e766d5d,
    name: "simulacao-seguro-vida-resultados-id-plan-details___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash?/results",
    component: _2ce62be0,
    name: "simulacao-seguro-automovel-resultados-id-hash-results___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/obrigado/:id?/:plan/obrigado",
    component: _6b176bb7,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan/contact",
    component: _146be733,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-multirriscos/resultados/:id?/:plan/details",
    component: _7df6dd1e,
    name: "simulacao-seguro-multirriscos-resultados-id-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/obrigado/:id?/:plan/obrigado",
    component: _35fd195a,
    name: "simulacao-seguro-saude-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/pedir-contacto/:id?/:plan/contact",
    component: _38e24117,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-saude/resultados/:id?/:plan/details",
    component: _f7490556,
    name: "simulacao-seguro-saude-resultados-id-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/obrigado/:id?/:plan/obrigado",
    component: _02aa7e1a,
    name: "simulacao-seguro-viagem-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/pedir-contacto/:id?/:plan/contact",
    component: _be384aa0,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-viagem/resultados/:id?/:plan/details",
    component: _1bd3cb6e,
    name: "simulacao-seguro-viagem-resultados-id-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/obrigado/:id?/:plan/obrigado",
    component: _19773b6a,
    name: "simulacao-seguro-vida-obrigado-id-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/pedir-contacto/:id?/:plan/contact",
    component: _e71425c2,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId/results",
    component: _4ff4f594,
    name: "simulacao-seguro-vida-resultados-id-companyId-results___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:plan/details",
    component: _3e766d5d,
    name: "simulacao-seguro-vida-resultados-id-plan-details___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan",
    component: _4788b22f,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan___en"
  }, {
    path: "/en/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan",
    component: _557c4684,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash",
    component: _aeb048a2,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan",
    component: _276f9a38,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId/:plan",
    component: _62cd8164,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan",
    component: _4788b22f,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan",
    component: _557c4684,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash",
    component: _aeb048a2,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan",
    component: _276f9a38,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId/:plan",
    component: _62cd8164,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan?/obrigado",
    component: _200ea0ed,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan-obrigado___en"
  }, {
    path: "/en/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan?/contact",
    component: _388b00fd,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan-contact___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/results",
    component: _2073e19c,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-results___en"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan?/details",
    component: _352f873b,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan-details___en"
  }, {
    path: "/en/simulacao-seguro-vida/resultados/:id?/:companyId/:plan?/details",
    component: _c5ffefde,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan-details___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan?/obrigado",
    component: _200ea0ed,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan-obrigado___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan?/contact",
    component: _388b00fd,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan-contact___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/results",
    component: _2073e19c,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-results___pt"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan?/details",
    component: _352f873b,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan-details___pt"
  }, {
    path: "/pt/simulacao-seguro-vida/resultados/:id?/:companyId/:plan?/details",
    component: _c5ffefde,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan-details___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan",
    component: _46d2b2a8,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan",
    component: _46d2b2a8,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan___pt"
  }, {
    path: "/en/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan/details",
    component: _2bf4fff7,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan-details___en"
  }, {
    path: "/pt/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan/details",
    component: _2bf4fff7,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan-details___pt"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id",
    component: _51a854cd,
    name: "simulacao-seguro-automovel-resultados-id"
  }, {
    path: "/simulacao-seguro-automovel/simulador-novo/:companyId",
    component: _6529aaa6,
    name: "simulacao-seguro-automovel-simulador-novo-companyId"
  }, {
    path: "/simulacao-seguro-automovel/simulador/:companyId",
    component: _b65d939c,
    name: "simulacao-seguro-automovel-simulador-companyId"
  }, {
    path: "/simulacao-seguro-multirriscos/resultados/:id",
    component: _3f0f9f75,
    name: "simulacao-seguro-multirriscos-resultados-id"
  }, {
    path: "/simulacao-seguro-saude/resultados/:id",
    component: _56e2e7de,
    name: "simulacao-seguro-saude-resultados-id"
  }, {
    path: "/simulacao-seguro-viagem/resultados/:id",
    component: _05260fd0,
    name: "simulacao-seguro-viagem-resultados-id"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id",
    component: _60e3d5ee,
    name: "simulacao-seguro-vida-resultados-id"
  }, {
    path: "/simulacao-seguro-vida/simulador/:companyId",
    component: _755cd96e,
    name: "simulacao-seguro-vida-simulador-companyId"
  }, {
    path: "/simulacao-seguro-automovel/simulador-novo/:companyId?/simulation",
    component: _65b33153,
    name: "simulacao-seguro-automovel-simulador-novo-companyId-simulation"
  }, {
    path: "/simulacao-seguro-automovel/simulador/:companyId?/simulation",
    component: _87241b50,
    name: "simulacao-seguro-automovel-simulador-companyId-simulation"
  }, {
    path: "/simulacao-seguro-casa/resultados/:id?/results",
    component: _c9773d84,
    name: "simulacao-seguro-casa-resultados-id-results"
  }, {
    path: "/simulacao-seguro-multirriscos/resultados/:id?/results",
    component: _57049696,
    name: "simulacao-seguro-multirriscos-resultados-id-results"
  }, {
    path: "/simulacao-seguro-saude/resultados/:id?/results",
    component: _71633d7a,
    name: "simulacao-seguro-saude-resultados-id-results"
  }, {
    path: "/simulacao-seguro-viagem/resultados/:id?/results",
    component: _64525253,
    name: "simulacao-seguro-viagem-resultados-id-results"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id?/results",
    component: _535658fc,
    name: "simulacao-seguro-vida-resultados-id-results"
  }, {
    path: "/simulacao-seguro-vida/simulador/:companyId?/simulador",
    component: _6b99f7ff,
    name: "simulacao-seguro-vida-simulador-companyId-simulador"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:hash",
    component: _193d8e2a,
    name: "simulacao-seguro-automovel-resultados-id-hash"
  }, {
    path: "/simulacao-seguro-multirriscos/obrigado/:id?/:plan",
    component: _aa0cb10e,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan"
  }, {
    path: "/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan",
    component: _912a7ce4,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan"
  }, {
    path: "/simulacao-seguro-multirriscos/resultados/:id?/:plan",
    component: _7d2e09ee,
    name: "simulacao-seguro-multirriscos-resultados-id-plan"
  }, {
    path: "/simulacao-seguro-saude/obrigado/:id?/:plan",
    component: _57b8e615,
    name: "simulacao-seguro-saude-obrigado-id-plan"
  }, {
    path: "/simulacao-seguro-saude/pedir-contacto/:id?/:plan",
    component: _d0e0c9ac,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan"
  }, {
    path: "/simulacao-seguro-saude/resultados/:id?/:plan",
    component: _11cfdcec,
    name: "simulacao-seguro-saude-resultados-id-plan"
  }, {
    path: "/simulacao-seguro-viagem/obrigado/:id?/:plan",
    component: _583812c8,
    name: "simulacao-seguro-viagem-obrigado-id-plan"
  }, {
    path: "/simulacao-seguro-viagem/pedir-contacto/:id?/:plan",
    component: _5097ea71,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan"
  }, {
    path: "/simulacao-seguro-viagem/resultados/:id?/:plan",
    component: _14c11c51,
    name: "simulacao-seguro-viagem-resultados-id-plan"
  }, {
    path: "/simulacao-seguro-vida/obrigado/:id?/:plan",
    component: _455b330d,
    name: "simulacao-seguro-vida-obrigado-id-plan"
  }, {
    path: "/simulacao-seguro-vida/pedir-contacto/:id?/:plan",
    component: _475b63bc,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id?/:companyId",
    component: _0e334656,
    name: "simulacao-seguro-vida-resultados-id-companyId"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id?/:plan",
    component: _055b0082,
    name: "simulacao-seguro-vida-resultados-id-plan"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:hash?/results",
    component: _2ce62be0,
    name: "simulacao-seguro-automovel-resultados-id-hash-results"
  }, {
    path: "/simulacao-seguro-multirriscos/obrigado/:id?/:plan/obrigado",
    component: _6b176bb7,
    name: "simulacao-seguro-multirriscos-obrigado-id-plan-obrigado"
  }, {
    path: "/simulacao-seguro-multirriscos/pedir-contacto/:id?/:plan/contact",
    component: _146be733,
    name: "simulacao-seguro-multirriscos-pedir-contacto-id-plan-contact"
  }, {
    path: "/simulacao-seguro-multirriscos/resultados/:id?/:plan/details",
    component: _7df6dd1e,
    name: "simulacao-seguro-multirriscos-resultados-id-plan-details"
  }, {
    path: "/simulacao-seguro-saude/obrigado/:id?/:plan/obrigado",
    component: _35fd195a,
    name: "simulacao-seguro-saude-obrigado-id-plan-obrigado"
  }, {
    path: "/simulacao-seguro-saude/pedir-contacto/:id?/:plan/contact",
    component: _38e24117,
    name: "simulacao-seguro-saude-pedir-contacto-id-plan-contact"
  }, {
    path: "/simulacao-seguro-saude/resultados/:id?/:plan/details",
    component: _f7490556,
    name: "simulacao-seguro-saude-resultados-id-plan-details"
  }, {
    path: "/simulacao-seguro-viagem/obrigado/:id?/:plan/obrigado",
    component: _02aa7e1a,
    name: "simulacao-seguro-viagem-obrigado-id-plan-obrigado"
  }, {
    path: "/simulacao-seguro-viagem/pedir-contacto/:id?/:plan/contact",
    component: _be384aa0,
    name: "simulacao-seguro-viagem-pedir-contacto-id-plan-contact"
  }, {
    path: "/simulacao-seguro-viagem/resultados/:id?/:plan/details",
    component: _1bd3cb6e,
    name: "simulacao-seguro-viagem-resultados-id-plan-details"
  }, {
    path: "/simulacao-seguro-vida/obrigado/:id?/:plan/obrigado",
    component: _19773b6a,
    name: "simulacao-seguro-vida-obrigado-id-plan-obrigado"
  }, {
    path: "/simulacao-seguro-vida/pedir-contacto/:id?/:plan/contact",
    component: _e71425c2,
    name: "simulacao-seguro-vida-pedir-contacto-id-plan-contact"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id?/:companyId/results",
    component: _4ff4f594,
    name: "simulacao-seguro-vida-resultados-id-companyId-results"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id?/:plan/details",
    component: _3e766d5d,
    name: "simulacao-seguro-vida-resultados-id-plan-details"
  }, {
    path: "/en/detalhes-companhia/:companyName?/:companyId?/:type",
    component: _60ddb676,
    name: "detalhes-companhia-companyName-companyId-type___en"
  }, {
    path: "/pt/detalhes-companhia/:companyName?/:companyId?/:type",
    component: _60ddb676,
    name: "detalhes-companhia-companyName-companyId-type___pt"
  }, {
    path: "/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan",
    component: _4788b22f,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan"
  }, {
    path: "/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan",
    component: _557c4684,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash",
    component: _aeb048a2,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan",
    component: _276f9a38,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id?/:companyId/:plan",
    component: _62cd8164,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan"
  }, {
    path: "/en/detalhes-companhia/:companyName?/:companyId?/:type?/detalhes-companhia",
    component: _034560ba,
    name: "detalhes-companhia-companyName-companyId-type-detalhes-companhia___en"
  }, {
    path: "/pt/detalhes-companhia/:companyName?/:companyId?/:type?/detalhes-companhia",
    component: _034560ba,
    name: "detalhes-companhia-companyName-companyId-type-detalhes-companhia___pt"
  }, {
    path: "/simulacao-seguro-automovel/obrigado/:id?/:hash?/:plan?/obrigado",
    component: _200ea0ed,
    name: "simulacao-seguro-automovel-obrigado-id-hash-plan-obrigado"
  }, {
    path: "/simulacao-seguro-automovel/pedir-contacto/:id?/:hash?/:plan?/contact",
    component: _388b00fd,
    name: "simulacao-seguro-automovel-pedir-contacto-id-hash-plan-contact"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/results",
    component: _2073e19c,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-results"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:hash?/:plan?/details",
    component: _352f873b,
    name: "simulacao-seguro-automovel-resultados-id-hash-plan-details"
  }, {
    path: "/simulacao-seguro-vida/resultados/:id?/:companyId/:plan?/details",
    component: _c5ffefde,
    name: "simulacao-seguro-vida-resultados-id-companyId-plan-details"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan",
    component: _46d2b2a8,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan"
  }, {
    path: "/simulacao-seguro-automovel/resultados/:id?/:companyId?/:hash?/:plan/details",
    component: _2bf4fff7,
    name: "simulacao-seguro-automovel-resultados-id-companyId-hash-plan-details"
  }, {
    path: "/detalhes-companhia/:companyName?/:companyId?/:type",
    component: _60ddb676,
    name: "detalhes-companhia-companyName-companyId-type"
  }, {
    path: "/detalhes-companhia/:companyName?/:companyId?/:type?/detalhes-companhia",
    component: _034560ba,
    name: "detalhes-companhia-companyName-companyId-type-detalhes-companhia"
  }, {
    path: "/",
    component: _778f8909,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
